import React from 'react';
 
import { NavLink } from 'react-router-dom';
 
const Navigation = () => {
   return (
      <div className="Navigation-App">
         <div className="logo">
            <img src={require('../Micro-bande logiciel.jpg')} alt={""} />
            <p>Ian Cy</p>
         </div>
         <div className="nav-menu">
            <NavLink to="/">Accueil</NavLink>
            <NavLink to="/about">À propos</NavLink>
            <NavLink to="/portfolio">Portfolio</NavLink>
            <NavLink to="/contact">Contact</NavLink>
         </div>
         <div className="contact">
            <p><img className="flavicon" src={require('../img/phone.svg')} alt={""} />+33 6 19 32 78 57 </p>
            <p><img className="flavicon" src={require('../img/at.svg')} alt={""} />maboiteavoix@gmail.com</p>
         </div>
      </div>
   );
}
 
export default Navigation;